import * as GuidedTourActions from 'app/guided-tour/state/guided-tour.actions';

import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';

import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ExerciseCategory } from 'app/document/components/document-planning/document-planning.component';
import { DocumentService } from 'app/exercise-program/services/document.service';
import { GuidedTourSelectors } from 'app/guided-tour/state/guided-tour.selectors';
import { GuidedTourDataService } from 'app/services/guided-tour-data.service';
import { OfflineService } from 'app/services/offline.service';
import { Exercise } from 'fitforce-document-sync';

@Component({
  selector: 'exercise-program-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit, AfterViewInit, OnDestroy {
  selectedExercise: Exercise;
  loading: boolean;
  offlineStatusSubscription: Subscription = new Subscription();
  private guidedTourStatusSubscription: Subscription = new Subscription();

  @Output() exerciseSelected: EventEmitter<Exercise> = new EventEmitter<Exercise>();

  guidedTourToggledOn = false;

  @Select(GuidedTourSelectors.toggleStatus)guidedTourToggleStatus$: Observable<boolean>;

  get exercises(): Exercise[] {
    if (this.documentService.store.exerciseProgram) {
      const val = this.documentService.store.exerciseProgram.document.exercises.sort(
        (a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1);
      this.loading = false;
      return val;
    }
  }

  get categories(): ExerciseCategory[] {
    if (this.documentService.store.exerciseProgram) {
      return this.documentService.store.exerciseProgram.document.exercise_categories.sort((a, b) => a.name < b.name ? -1 : 1);
    }
  }

  constructor(private documentService: DocumentService,
    private offline: OfflineService,
    private router: Router,
    private snackBar: MatSnackBar,
    private guidedTourDataService: GuidedTourDataService,
    private store: Store) {}

  ngOnInit() {
    this.loading = true;
    this.documentService.restoreData().subscribe();

    this.offlineStatusSubscription = this.offline.status.subscribe(value => {
      const isOnline = value;
      if (!isOnline) {
        this.snackBar.open('Exercise Program is not available in offline mode.', 'Dismiss', { duration: 5000 });
        this.router.navigate(['dashboard']);
      }
    });

  }

  ngAfterViewInit() {
    this.store.dispatch(new GuidedTourActions.GetGuidedTourToggleStatus());
    this.guidedTourStatusSubscription = this.guidedTourToggleStatus$.subscribe(status => {
      if (status !== undefined) {
        this.guidedTourToggledOn = status;
        if (this.guidedTourToggledOn) {
          setTimeout(() => this.guidedTourDataService.startGuidedTour('exercise-program'), 1000);
        }
      }
    });
  }

  ngOnDestroy() {
    this.offlineStatusSubscription.unsubscribe();
    this.guidedTourStatusSubscription.unsubscribe();
  }

  selectExercise(exercise: Exercise) {
    this.exerciseSelected.emit(exercise);
    this.selectedExercise = exercise;
  }

}
